import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function IncidentsTab() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/hs/sites").then(async r => {
      const out = await Promise.all(r.data.map(async s => {
        const { data } = await api.get(`/projects/${s.id}/hs/incidents`).catch(() => ({ data: [] }));
        return { ...s, total: data.length, open: data.filter(i => i.status !== "Closed").length };
      }));
      setRows(out);
    });
  }, []);
  if (!rows) return <div className="opacity-70">Loading…</div>;
  return (
    <div className="card overflow-x-auto" data-testid="hs-incidents-tab">
      <div className="text-sm opacity-70 mb-2">Incidents are logged and closed in each project's incident register.</div>
      <table className="table w-full text-sm">
        <thead><tr><th>Project</th><th>Open</th><th>Total</th><th></th></tr></thead>
        <tbody>
          {rows.map(s => (
            <tr key={s.id} data-testid={`hs-incident-row-${s.id}`}>
              <td>{s.name}</td><td className={s.open ? "text-amber-400" : ""}>{s.open}</td><td>{s.total}</td>
              <td><Link className="hub-link" to={`/projects/${s.id}/hs`} data-testid={`hs-incident-link-${s.id}`}>Open incident register</Link></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
